export const questionTypes = [
  { value: "choice", label: "選擇題" },
  { value: "fill", label: "填充題" },
  { value: "calculation", label: "計算題" },
  { value: "proof", label: "證明題" },
  { value: "application", label: "應用題" },
];

export const questionDifficulties = [
  { value: "U", label: "未分類" },
  { value: "C", label: "C 基礎型" },
  { value: "B", label: "B 進階型" },
  { value: "A", label: "A 挑戰型" },
  { value: "S", label: "S 究極型" },
];

export const questionVisibilities = [
  { value: "public", label: "公開題目" },
  { value: "private", label: "私有題目" },
];

export const publicDraftQuestionMeta = {
  status: "draft",
  visibility: "public",
};

export const inferQuestionType = (question) =>
  (question?.options || []).some((option) => option?.text?.trim())
    ? "choice"
    : "calculation";

export const getRecordId = (record) =>
  record?.id === undefined && record?.uuid === undefined
    ? ""
    : String(record.id || record.uuid);

export const getUnitGradeId = (unit) => {
  const gradeId = unit?.grade?.id || unit?.grade_id || unit?.grade;
  return gradeId === undefined || gradeId === null ? "" : String(gradeId);
};
